module dg.lists {

    export class PlotlyChartController {

        public plotlyData: any;
        public plotlyLayout: any;
        public plotlyOptions: any;
        public plotlyEvents: any;
        private Plotly: any;
        public isInitialized: boolean;
        public data: boolean;
        public dataRendered: boolean;
        private graph: any
        public loading: any;
        public loadingStyle = { height: '0px' };

        public getChildController: any;

        public constructor(
            private $window: ng.IWindowService,
            private $timeout: ng.ITimeoutService,
            private $element: ng.IAugmentedJQuery,
            public $scope: ng.IScope
        ) {
            this.isInitialized = false;
            this.graph = $element[0].children[0];
            
            this.Plotly = $window.Plotly;

            this.setLoadingHeight();
        }

        $onInit = () => {
            let controller = this;
            this.getChildController({ controller: controller });

            angular.element(this.$window).on('resize', this.onResize);
        }

        $onDestroy() {
            angular.element(this.$window).off('resize', this.onResize);
        }

        public isLoaded() {
            return this.loading.loaded && this.dataRendered && this.isInitialized;
        }

        subscribeToEvents(graph) {
            this.plotlyEvents(this.graph);
        }

        public onUpdate() {

            this.dataRendered = false;
            //No data yet, or clearing out old data
            if (!(this.plotlyData)) {
                if (this.isInitialized) {
                    this.Plotly.Plots.purge(this.graph);
                    this.graph.innerHTML = '';
                }
                return;
            }
            //If this is the first run with data, initialize
            if (!this.isInitialized) {

                this.Plotly.newPlot(this.graph, this.plotlyData, this.plotlyLayout, this.plotlyOptions);
                if (this.plotlyEvents) {
                    this.subscribeToEvents(this.graph);
                }
                this.setLoadingHeight();
                this.isInitialized = true;
            }
            else {
                this.graph.layout = this.plotlyLayout;


                this.graph.data = this.plotlyData;

                //if (this.plotlyEvents) {
                //    this.subscribeToEvents(this.graph);
                //}

                this.Plotly.redraw(this.graph);

                this.Plotly.Plots.resize(this.graph);

                this.dataRendered = true;
            }
        }

        private onResize = () => {
            if (!(this.isInitialized && this.plotlyData)) return;

            this.Plotly.Plots.resize(this.graph);
        }

        public setLoadingHeight = () => {
            this.loadingStyle.height = $(this.graph).height() + 'px';
        }

        public resetChart = () => {
            this.Plotly.Plots.purge(this.graph);
            this.graph.innerHTML = '';
            this.isInitialized = false;
        }

        $onChanges = (changes) => {
            if (changes.plotlyLayout.currentValue !== changes.plotlyLayout.previousValue) {
                this.onUpdate();
            }

            if (changes.plotlyData.currentValue !== changes.plotlyData.previousValue) {
                this.onUpdate();
            }
        }
    }

    angular.module('dg.lists').component('plotlyChart', {
        bindings: {
            plotlyData: '<',
            plotlyLayout: '<',
            plotlyOptions: '<',
            plotlyEvents: '<',
            loading: '<',
            getChildController: '&'
        },
        controller: PlotlyChartController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart.html'
    });
}